import { BatteryChargingIcon, FuelIcon, HardHatIcon, PlugZapIcon, ServerIcon, SnowflakeIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Data Center Fundamentals: Architecture, Redundancy & Availability',
    summary: 'Facility layout, IT load, Tier concepts, redundancy (N, N+1, 2N), availability, single points of failure, key metrics.',
    icon: ServerIcon,
  },
  {
    number: '2',
    title: 'Critical Power Distribution: From Utility to Rack',
    summary: 'Utility service, medium and low voltage switchgear, transformers, distribution boards, PDUs, busways, rack power, grounding and protection.',
    icon: PlugZapIcon,
  },
  {
    number: '3',
    title: 'UPS Systems & Battery Energy Storage',
    summary: 'UPS topologies, operating modes, static and maintenance bypass, parallel and redundant systems, VRLA and lithium-ion batteries, monitoring.',
    icon: BatteryChargingIcon,
  },
  {
    number: '4',
    title: 'Standby Power: Generators, Transfer Systems & Fuel',
    summary: 'Diesel generators, sizing concepts, automatic transfer switches, paralleling, load bank testing, fuel storage and fuel quality.',
    icon: FuelIcon,
  },
  {
    number: '5',
    title: 'Cooling & Mechanical Systems: From Air to Liquid',
    summary: 'Heat load, chillers, cooling towers, CRAH and CRAC units, airflow management, containment, economizers, liquid and direct-to-chip cooling.',
    icon: SnowflakeIcon,
  },
  {
    number: '6',
    title: 'Operations, Maintenance, Commissioning & Electrical Safety',
    summary: 'Operating procedures, change control, preventive maintenance, commissioning levels, MOPs, lockout/tagout, arc flash awareness, incident response.',
    icon: HardHatIcon,
  },
];
